<template>
    <div class="nk-header nk-header-fluid nk-header-fixed is-light attribute-fixed bg-lighter">
        <div class="container-lg wide-lg">
            <div class="nk-header-wrap">
                <div class="nk-header-brand">
                    <router-link :to="{name:'home'}" class="logo-link">
                        <img class="logo-dark logo-img logo-img-md" src="../assets/images/logo.png" alt="logo">
                    </router-link>
                </div>
                <div class="nk-header-menu ml-auto">
                    <ul class="nk-menu nk-menu-main d-flex">
                        <li class="nk-menu-item">
                            <a href="https://kitalog.rabbani.id/" target="_blank" class="color-bekam nk-menu-link">
                                <span class="nk-menu-text">Katalog</span>
                            </a>
                        </li>
                        <li class="nk-menu-item">
                            <a href="https://rabbani.id/" target="_blank" class="color-bekam nk-menu-link">
                                <span class="nk-menu-text">Rabbani.id</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        
    },
}
</script>